export default __webpack_public_path__ + "static/media/0x554f074d9ccda8f483d1812d4874cbebd682644e.0601940e.webp";